import { ConfigService } from '@nextgen-web-framework/core';
import { useMasterData } from '@nextgen-web-framework/all';
import { IdentityUsernameConfig, UsernameType, Tenants, OperationType } from '@commerce-identity-webcomponents/sdk';
import { CountryInterface } from '@com.amway.commerce/masterdata-country-v1-production/Schema';
interface UsernameConfiguration {
  type: UsernameType;
  data?: CountryInterface[] | void;
}

const useUsernameConfiguration = (operation: OperationType): UsernameConfiguration => {
  const identityUsernameConfigData = useMasterData('IdentityUsernameConfig') as IdentityUsernameConfig;
  const masterCountryData = useMasterData('MasterCountryList') as CountryInterface[];
  const calculateCustomCountryDataList = (pks?: string[]) => {
    const countryList: CountryInterface[] = [];
    pks?.forEach((element: string) => {
      for (let i = 0; i < masterCountryData?.length; i++) {
        if (masterCountryData[i]?.pk == element) {
          countryList.push(masterCountryData[i]);
          break;
        }
      }
    });
    return countryList;
  };
  const { NEXT_PUBLIC_TENANT_NAME } = ConfigService.getConfigs();
  const operationsConfig = identityUsernameConfigData?.operations;
  const defaultOperationConfig = operationsConfig?.[operation as OperationType];
  const defaultUsernameType = defaultOperationConfig?.username?.type;
  const customTenantConfig = identityUsernameConfigData?.tenants?.[NEXT_PUBLIC_TENANT_NAME as keyof Tenants];
  const customOperationConfig = customTenantConfig?.[operation as OperationType] || defaultOperationConfig;
  const customUsernameType = customOperationConfig?.username?.type;
  const type = customUsernameType || defaultUsernameType || UsernameType.EMAIL_PHONE;
  const data =
    customOperationConfig?.country?.type == 'DEFAULT'
      ? masterCountryData
      : calculateCustomCountryDataList(customOperationConfig?.country?.allowedPk);
  return {
    type,
    data,
  };
};

export default useUsernameConfiguration;
